import TenantLeaseEditContainer from './TenantLeaseEditContainer'

export default TenantLeaseEditContainer
